import React from "react";
import { useNavigate } from "react-router-dom";
import meSquare from "../../assets/me_square.jpg";
import "./introPage.css";

const IntroPage = () => {
	const navigate = useNavigate();

	return (
		<div className="intro-page">
			<div className="intro-content">
				<h1 className="intro-main">Claude Nijem</h1>
				<p className="intro-subtitle">
					Developing to bring out the smile in you.
				</p>
				<div
					role={"button"}
					className="btn"
					onClick={() => {
						navigate("/about");
					}}
				>
					Read More!
				</div>
			</div>
			<div className="intro-img">
				<img src={meSquare} alt="me" />
			</div>
		</div>
	);
};

export default IntroPage;
